import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './services/userService/auth.guard';

const routes: Routes = [
  {
    path: '',
    loadChildren: () => import('./tabs/tabs.module').then(m => m.TabsPageModule),
  },
  {
    path: 'homepage',
    loadChildren: () => import('./home/home.module').then( m => m.HomePageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'profil',
    loadChildren: () => import('./profil/profil.module').then( m => m.ProfilPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'login',
    loadChildren: () => import('./login/login.module').then( m => m.LoginPageModule)
  },
  {
    path: 'detail-video/:myid',
    loadChildren: () => import('./detail-video/detail-video.module').then( m => m.DetailVideoPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'safe-training',
    loadChildren: () => import('./safe-training/safe-training.module').then( m => m.SafeTrainingPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'events',
    loadChildren: () => import('./events/events.module').then( m => m.EventsPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'detail-event',
    loadChildren: () => import('./events-detail/events-detail.module').then( m => m.EventsDetailPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'case-studies',
    loadChildren: () => import('./case-studies/case-studies.module').then( m => m.CaseStudiesPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'faq',
    loadChildren: () => import('./faq/faq.module').then( m => m.FAQPageModule)

  },
  {
    path: 'contact-us',
    loadChildren: () => import('./contact-us/contact-us.module').then( m => m.ContactUsPageModule)

  },
  {
    path: 'livewebinars',
    loadChildren: () => import('./livewebinars/livewebinars.module').then( m => m.LivewebinarsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'replaywebinars',
    loadChildren: () => import('./replaywebinars/replaywebinars.module').then( m => m.ReplaywebinarsPageModule),
    canActivate: [AuthGuard]
  },
  {
    path: 'events-detail',
    loadChildren: () => import('./events-detail/events-detail.module').then( m => m.EventsDetailPageModule)
  },
  {
    path: 'replay-webinar-list',
    loadChildren: () => import('./replay-webinar-list/replay-webinar-list.module').then( m => m.ReplayWebinarListPageModule)
  },
  {
    path: 'courses-list',
    loadChildren: () => import('./courses-list/courses-list.module').then( m => m.CoursesListPageModule)
  },
  {
    path: 'courses-home',
    loadChildren: () => import('./courses-home/courses-home.module').then( m => m.CoursesHomePageModule)
  },
  {
    path: 'favorites',
    loadChildren: () => import('./favorites/favorites.module').then( m => m.FavoritesPageModule)
  },
  {
    path: 'my-alerts',
    loadChildren: () => import('./my-alerts/my-alerts.module').then( m => m.MyAlertsPageModule)
  },
  {
    path: 'detail-safe-training',
    loadChildren: () => import('./detail-safe-training/detail-safe-training.module').then( m => m.DetailSafeTrainingPageModule),
    canActivate: [AuthGuard]

  },
  {
    path: 'legal-notice',
    loadChildren: () => import('./legal-notice/legal-notice.module').then( m => m.LegalNoticePageModule),
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./privacy-policy/privacy-policy.module').then( m => m.PrivacyPolicyPageModule),
  },
  {
    path: 'livewebinar-youtube',
    loadChildren: () => import('./livewebinar-youtube/livewebinar-youtube.module').then( m => m.LivewebinarYoutubePageModule)
  },


];
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      anchorScrolling: 'enabled',
      scrollPositionRestoration: 'enabled',
      preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
